import { useState } from "react";
import Link from "next/link";
import classNames from "classnames/bind";
import { Size as SizeType } from "./types";
import Size from "@JohnLewisPartnership/jl-design-system/dist/components/size/Size";
import Minus24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Minus24PxOutlined";
import Plus24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Plus24PxOutlined";
import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./Sizes.module.scss";

const cx = classNames.bind(styles);

type SizeItemsProps = {
  sizes: SizeType[];
  showMore?: number;
  groupName?: string;
};

export const SizeItems = ({ sizes, showMore, groupName }: SizeItemsProps) => {
  const [isOpen, setOpen] = useState(false);
  const visibleSizes = sizes.filter(
    (size, index) =>
      isOpen || size.isSelected || (showMore && index < showMore) || !showMore,
  );

  const hiddenItems = sizes.length - visibleSizes.length;

  const isButtonVisible = !!showMore && ((!isOpen && !!hiddenItems) || isOpen);

  return (
    <li
      role="group"
      className={cx("group", { reducedMargin: !isButtonVisible })}
    >
      {groupName && <h5 className={styles.heading}>{groupName}</h5>}
      <ul className={styles.groupSizesList}>
        {visibleSizes.map((size, index) => {
          return (
            <Size
              key={`size-${index}`}
              id={`size-${size.name}`}
              data-testid="size:option"
              unavailable={size.unavailable}
              value={size.name}
              selected={size.isSelected}
              hasReducedPrice={size.showReduced}
              reducedPriceText={size.sizeReductionLabel}
              minimiseLabelPadding={true}
              Tag={Link}
              buttonProps={{
                href: size.url,
                shallow: true,
                scroll: false,
              }}
            >
              {size.name}
            </Size>
          );
        })}
      </ul>
      {!!showMore && ((!isOpen && !!hiddenItems) || isOpen) && (
        <TertiaryButton
          small={true}
          onClick={() => setOpen((toggle) => !toggle)}
          IconComponent={() =>
            isOpen ? <Minus24PxOutlined /> : <Plus24PxOutlined />
          }
          className={styles.showMore}
          iconPositionRight
        >
          {isOpen ? "Show less" : `Show ${hiddenItems} more`}
        </TertiaryButton>
      )}
    </li>
  );
};
